import styled from 'styled-components';
import colors from 'styles/colors';

export const StyledErrorMessage = styled.span`
  font-size: 16px;
  color: ${colors.Red};
  line-height: 1.5;
  text-align: left;
`;